import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject, NgZone } from '@angular/core';
import { catchError, timeout, switchMap, finalize } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { LoadingService } from '../service/loading.service';
import { ErrorModalService } from '../service/error-modal.service';

export const globalHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const errorModalService = inject(ErrorModalService);
  const ngZone = inject(NgZone);

  const executeRequest = (): Observable<any> => {
    loadingService.increment();

  return next(req).pipe(
    timeout(15000),
    catchError((error: any) => {
      // Tvinga bort spinnern omedelbart när ett fel dyker upp så att modalen syns fritt
      loadingService.forceHide();

      let title = 'Ett fel uppstod';
      let message = 'Ett oväntat fel uppstod.';
      let type: 'timeout' | 'network' | 'server' | 'request' = 'server';
      let showRetry = true;

      if (error?.name === 'TimeoutError') {
        title = 'Timeout';
        message = 'Förfrågan tog för lång tid. Kontrollera din anslutning eller försök igen.';
        type = 'timeout';
      } else if (error instanceof HttpErrorResponse) {
        if (error.status === 0) {
          title = 'Nätverksfel';
          message = 'Kunde inte ansluta till servern. Kontrollera din internetanslutning eller om servern är nere.';
          type = 'network';
        } else if (error.status >= 500) {
          title = 'Serverfel / Databasfel';
          message = 'Ett internt serverfel eller databasfel uppstod. Försök igen senare.';
          type = 'server';
        } else if (error.status >= 400) {
          title = 'Förfrågningsfel';
          message = `Förfrågan kunde inte slutföras (${error.status}).`;
          type = 'request';
          showRetry = false;
        }
      } else if (error?.message) {
        message = error.message;
      }

      const modalResult$: Observable<boolean> = ngZone.run(() => {
        return errorModalService.showError(title, message, type, showRetry);
      });

      return modalResult$.pipe(
        switchMap((retry: boolean) => {
          if (retry === true) {
            return executeRequest();
          } else {
            return throwError(() => error);
          }
        })
      );
    }),
    );
  };
  return executeRequest().pipe(
    finalize(() => {
      // Minska räknaren vid normal/lyckad slutförning
      loadingService.decrement();
    })
  );
};
